export function isMobileDeviceClient() {

  return /iPhone|iPad|iPod|kindle|Android/i.test(navigator.userAgent)
}